import { Button } from "primereact/button";
import { Sidebar } from "primereact/sidebar";
import { Tag } from "primereact/tag";
import useApi from "../../hooks/ApiHook";
import useToast from "../../hooks/ToastHook";
import { useEffect, useState } from "react";
import Loading from "../../components/Loading";

const statusTags = {
    PROCESSING: <Tag className="mr-2" severity="info" value="PROCESSANDO"/>,
    SUCCESS: <Tag className="mr-2" severity="success" value="SUCESSO"/>,
    ERROR: <Tag className="mr-2" severity="danger" value="ERRO"/>,
    CANCELED: <Tag className="mr-2" severity="danger" value="CANCELADA"/>
}

export default function({ order: orderProp, onHide, onChange }) {

    const api = useApi();
    const [ order, setOrder ] = useState();
    const [ loading, setLoading ] = useState(false);

    useEffect(() => {
        setOrder(orderProp);
    }, [orderProp]);

    const onCancelNfe = () => {
        onChange();
        setLoading(true);
        api.get(`orders/${order.id}`).then(({ data }) => {
            setOrder(data);
        }).finally(() => {
            setLoading(false);
        });
    }

    return (
        <Sidebar visible={order} position="right" className="md:w-4" onHide={onHide}>
            <div className="h-full flex flex-column">
                <h2>Lista NFe</h2>
                {loading ? (
                    <Loading/>
                ) : (
                    <>
                        {order && (
                            <>
                                <div className="w-full flex-grow-1 mt-4 max-w-full flex-shrink-1 overflow-y-hidden overflow-y-scroll">
                                    {order.nfeList.map(i => <Item item={i} onCancel={onCancelNfe}/>)}
                                </div>
                            </>
                        )}
                    </>
                )}
            </div>
        </Sidebar>
    );
}

function Item({ item, onCancel }) {

    const api = useApi();
    const toast = useToast();
    const [ cancelling, setCancelling ] = useState(false);

    const cancel = () => {
        setCancelling(true);
        api.delete(`nfe/${item.nfeId}`).then(() => {
            toast.showSuccess('Nota cancelada com sucesso');
            onCancel();
        }).catch(e => {
            toast.showAxiosError(e);
        }).finally(() => {
            setCancelling(false);
        });
    }

    return (
        <div className="py-4 border-solid border-none border-bottom-1 border-300">
            <div className="font-bold mb-2 cursor-pointer hover:text-color-secondary" onClick={() => openFile(item.xmlUri)}>
                {statusTags[item.status]}{item.nfeId}
            </div>
            <div className="mb-2">
                <span className="font-bold">Mensagem: </span>
                {item.message}
            </div>
            {item.danfeUri && (
                <div className="mb-2">
                    <span className="font-bold">Danfe: </span>
                    <span className="cursor-pointer hover:text-color-secondary" onClick={() => openFile(item.danfeUri)}>
                        Abrir Danfe PDF da nota
                    </span>
                </div>
            )}
            {item.status !== 'CANCELED' && (
                <>
                    {cancelling ? (
                        <div className="mb-2">
                            <span className="font-bold">Cancelando...</span>
                        </div>
                    ) : (
                        <div className="mb-2" onClick={cancel}>
                            <span className="cursor-pointer hover:text-color-secondary">Cancelar nota</span>
                        </div>
                    )}
                </>
            )}
        </div>
    )
}

function openFile(uri) {
    window.open(uri, '_blank').focus();
}